<template>
  <d-container fluid class="main-content-container px-4 pb-4">
    <!-- Error -->
    <div class="error">
      <div class="error__content">
        <h2>403</h2>
        <h3>L'accès à cette page vous est refusé !</h3>
        <p>
          Il s'avère que votre compte ne possède pas les droits nécessaires pour
          afficher cette page.
        </p>
        <d-button pill @click="$router.back()">&larr; Retour</d-button>
      </div>
    </div>
  </d-container>
</template>

<script>
export default {
  name: 'PermissionDenied',
};
</script>
